<template>
  <div class="advanced-cookie-dialogue__outer">
    <div
      v-if="!chosenCookies.isUpdated && isCustom"
      class="advanced-cookie-dialogue__overlay"
    ></div>

    <div
      v-if="!chosenCookies.isUpdated"
      class="advanced-cookie-dialogue"
      :class="{ 'advanced-cookie-dialogue--choices': isCustom }"
    >
      <div class="advanced-cookie-dialogue__container">
        <p class="advanced-cookie-dialogue__description">
          {{ initialDescription }}
          <a
            href="/informasjonskapsler/"
            class="advanced-cookie-dialogue__link"
            >Les mer om vår bruk av informasjonskapsler her</a
          >.
        </p>
        <ActionButton v-if="!isCustom" text="Godta alle" @click="onAcceptAll" />
        <ActionButton
          v-if="!isCustom"
          text="Tilpass dine valg"
          @click="isCustom = true"
        />
        <div v-if="isCustom" class="advanced-cookie-dialogue__choices">
          <p>{{ customomizeDescription }}</p>
          <InputCheckbox
            id="advanced-cookie-dialogue__essential"
            :label="cookieEssentialTitle"
            name="Essensielle"
            :description="cookieEssentialDescription"
            v-model="chosenCookies.isEssentials"
            disabled
          />
          <InputCheckbox
            id="advanced-cookie-dialogue__analytics"
            :label="cookieAnalyticsTitle"
            name="Analyse"
            :description="cookieAnalyticsDescription"
            v-model="chosenCookies.isAnalytics"
          />
          <ActionButton v-if="isCustom" text="Lagre" @click="onSave" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setCookie, getCookie } from "./cookies";
import InputCheckbox from "./components/InputCheckbox";
import ActionButton from "./components/ActionButton";

const initialCookieSettings = {
  isUpdated: false,
  isEssentials: true,
  isAnalytics: false
};

export default {
  name: "App",
  components: {
    InputCheckbox,
    ActionButton
  },
  props: {
    initialDescription: {
      type: String,
      required: false,
      default: ""
    },
    customomizeDescription: {
      type: String,
      required: false,
      default: ""
    },
    cookieEssentialTitle: {
      type: String,
      required: false,
      default: ""
    },
    cookieEssentialDescription: {
      type: String,
      required: false,
      default: ""
    },
    cookieAnalyticsTitle: {
      type: String,
      required: false,
      default: ""
    },
    cookieAnalyticsDescription: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      isCustom: false,
      chosenCookies: {
        isUpdated: false,
        isEssentials: true,
        isAnalytics: false
      }
    };
  },
  methods: {
    onAcceptAll() {
      this.chosenCookies.isEssentials = true;
      this.chosenCookies.isAnalytics = true;
      this.onSave();
    },
    onSave() {
      this.chosenCookies.isUpdated = true;
      const content = JSON.stringify(this.chosenCookies);

      setCookie({
        name: "ppfinans-cookie-settings",
        content: content,
        secure: true
      });

      window.location.reload();
    },
    onChoose(property, value) {
      this.chosenCookies[property] = value;
    },
    onOnlyEssential() {
      this.chosenCookies = initialCookieSettings;
      this.onSave();
    }
  },
  created() {
    const cookieContent = getCookie("ppfinans-cookie-settings");
    if (cookieContent) {
      const cookieObject = JSON.parse(cookieContent);
      this.chosenCookies = cookieObject;
    }
  }
};
</script>

<style lang="scss">
.advanced-cookie-dialogue__overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background-color: black;
  opacity: 0.4;
}

.advanced-cookie-dialogue {
  width: 100%;
  height: auto;
  position: fixed;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  font-size: 2rem;
  line-height: 2.75rem;
  color: black;
  padding: 2rem;
  background-color: white;
  display: flex;
  justify-content: center;
  box-shadow: 1px 1px 2px 2px #0000005e;
  font-family: "RalewayMedium", Helvetica, Arial, sans-serif;

  &--choices {
    max-width: 500px;
    height: auto;
    position: fixed;
    top: auto;
    right: auto;
    bottom: 4rem;
    left: 4rem;
    display: flex;
    justify-content: left;
  }

  &__container {
    max-width: 1140px;
  }

  &__description {
    margin: 2rem 0;
  }
}
</style>
